<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form">
          <Loader v-if="loading" style="min-height:200px" />
          <slot v-if="step == 1 && !loading">
            <div class="col" v-if="!_.isNull(error_message)">
              <div class="alert alert-danger" style="text-align:center;width: 100%; margin-bottom: 10px;" >
                <label>{{ error_message }}</label>
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>Tutar</label>
                <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
               <button class="button primary" type="button" @click="toStep(2)">Sonraki Adım</button>
              </div>
            </div>
          </slot>
          <slot v-if="step == 2 && !loading">
            <div class="col">
                <div class="inline-form">
                    <label>Banka <span style="color:var(--client-c3);">(Zorunlu)</span></label>
                    <select @change="activeBank = form.account" v-model="form.account" v-if="!_.isEmpty(banks)">
                        <option :value="null" disabled>Seçiniz</option>
                        <option v-show="form.amount >= item.minPayment && form.amount <= item.maxPayment" v-for="item in banks" :key="item.id" :value="item">{{ item.bankName }}</option>
                    </select>
                </div>
            </div>
            <slot v-if="!_.isEmpty(activeBank)">
              <div class="col">
                <div class="inline-form" >
                  <div class="alert alert-success alert-pay animated pulse" v-if="!_.isNull(bank)">
                      <div class="alert-items" v-if="!_.isNull(activeBank.accountOwner)">
                        <b>Hesap Sahibi:</b> 
                        <div class="item">
                          {{ activeBank.accountOwner }} 
                          <div class="button primary small-btn" @click="copy(activeBank.accountOwner)">
                            <svg x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"> <g id="XMLID_351_"> <path id="XMLID_352_" d="M235,0H35c-8.284,0-15,6.716-15,15v240c0,8.284,6.716,15,15,15h15v-30V30h55.751H220h30V15   C250,6.716,243.284,0,235,0z"/> <polygon id="XMLID_439_" points="220,88.787 200,68.787 200,111.213 200,170 258.787,170 301.214,170 250,118.787  "/> <path id="XMLID_440_" d="M95,330h200c8.284,0,15-6.716,15-15V200h-8.786H280h-21.213H200h-15c-8.284,0-15-6.716-15-15v-15v-58.787   V90V68.787V60h-64.249H95c-8.284,0-15,6.716-15,15v165v30v37.883V315C80,323.284,86.716,330,95,330z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                            Kopyala
                          </div>
                        </div>
                      </div> 
                      <div class="alert-items" v-if="!_.isNull(activeBank.bankIban)">
                        <b>IBAN:</b>
                      <div class="item">
                          {{ activeBank.bankIban }} 
                          <div class="button primary small-btn" @click="copy(activeBank.bankIban)">
                            <svg x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"> <g id="XMLID_351_"> <path id="XMLID_352_" d="M235,0H35c-8.284,0-15,6.716-15,15v240c0,8.284,6.716,15,15,15h15v-30V30h55.751H220h30V15   C250,6.716,243.284,0,235,0z"/> <polygon id="XMLID_439_" points="220,88.787 200,68.787 200,111.213 200,170 258.787,170 301.214,170 250,118.787  "/> <path id="XMLID_440_" d="M95,330h200c8.284,0,15-6.716,15-15V200h-8.786H280h-21.213H200h-15c-8.284,0-15-6.716-15-15v-15v-58.787   V90V68.787V60h-64.249H95c-8.284,0-15,6.716-15,15v165v30v37.883V315C80,323.284,86.716,330,95,330z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
                            Kopyala
                          </div>
                        </div>
                      </div> 
                  </div>
                </div>
              </div>
              <div class="alert" style="margin:0px 0 10px 0">
                <b>Yukarıda belirtilen Banka Hesabı sadece bu işlem için geçerlidir. Lütfen her ödemeniz için güncel hesabı alınız. Aksi takdirde sorumluluk tarafımıza ait değildir.</b>
              </div>

              <div class="alert" style="margin:10px 0">
                <b>Yukarıda ki hesaba transfer işleminizi gerçekleştirdikten sonra "Ödemeyi Yaptım" düğmesine basınız. Aksi takdirde işleminiz iptal olacaktır.</b>
              </div>
              <div class="alert" style="margin: 10px 0px; font-size: 15px; color: var(--client-c3);">
                <b>Eğer farklı isim üzerinden gönderim sağlayacaksanız aşağıdaki bölümü doldurunuz aksi takdirde ödemeniz onaylanmayacaktır</b>
              </div>
              
              <div class="col">
                <div class="inline-form d-flex flow-row align-center">
                  <input type="checkbox" id="checkbox-note" checked='checked' v-model="form.is_note"/>
                  <label for="checkbox-note" style="margin:0px">Farklı isim üzerinden göndereceğim</label>
                </div>
              </div>
              <div class="col" v-if="form.is_note">
                <div class="inline-form">
                  <label>Gönderim Yapılan Ad Soyad</label>
                  <input placeholder="Gönderim Yapılan Ad Soyad" v-model="form.note">
                </div>
              </div>
              
              <div class="col">
                <ButtonLoader @click.native="send" class="primary block" :loader="btnLoading" :text="'Ödemeyi Yaptım'" />
              </div>
            </slot>
          </slot>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props:['providerInfo'],
    data(){
      return{
        btnLoading: false,
        step:1,
        loading:false,
        error_message:null,
        activeBank:{},
        banks:[],
        form: {
            note:null,
            is_note:false,
            account:null,
            amount: null,
        },
      }
    },
    created(){
    },
    methods:{
      copy(textToCopy) {
        const tmpTextField = document.createElement("textarea")
        tmpTextField.textContent = textToCopy
        tmpTextField.setAttribute("style","position:absolute; right:200%;")
        document.body.appendChild(tmpTextField)
        tmpTextField.select()
        tmpTextField.setSelectionRange(0, 99999) /*For mobile devices*/
        document.execCommand("copy")
        this.$store.dispatch('alert/message', { type: 'success', msg: 'Kopyalandı!' })
      },
      toStep(step){
        if(step == 2){
          if(this.form.amount > 0){
            this.getBankList();
          }
          else{
            this.$store.dispatch('alert/message', { type: 'error', msg: 'Tutar yazınız' })
          }
        }
      },
      getBankList()
      {
          this.error_message = null
          this.loading = true
          axios.get('/user/wallet/deposit/cashmoneytwo/list', { params:{ amount: this.form.amount}} )
          .then((response) => {
              this.banks = response.data.list;
              this.loading = false;
              if(response.data.status){
                this.step = 2;
              }else{
                this.error_message = response.data.message
              }
          })
          .catch((err) => {
          })
          .finally(() => {
          });
      },
      send() {
        this.btnLoading = true;
        axios.post('/user/wallet/deposit/cashmoneytwo/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          }
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Form
    }
  }

</script>

<style scoped lang="scss"> 
   .small-btn{
    width: 70px;
    font-size: 10px !important;
    svg{
      width: 10px;
      height: 10px;
    }
   }
   .alert{
    text-align: left;
    .alert-items{
      margin-top: 10px;
      b{
        color: var(--client-c3);
      }
      .item{
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 900;
        .button{
          margin-left: 10px;
        }
      }
    }
   }
</style>

<style lang="scss">
  input[type=checkbox]{
    width: 20px !important;
    height: 20px !important;
    &::after{
      top: 6px !important;
      left: 6px !important;
    }
  }
  .line-title{
    height: auto !important;
  }
</style>